import { useEffect } from 'react';
import getUrlParams from '@gcloud-npm/utils.common.get-url-params';
import { useDispatch, useSelector } from 'react-redux';

function useInitPurchase({
  segment,
  initPurchase,
  setSegment,
  setZone,
  loaded,
}) {
  const dispatch = useDispatch();
  const mainPostalCode = useSelector((state) => state.main.cp);
  const mainZone = useSelector((state) => state.main.zone);

  useEffect(() => {
    const {
      productOfferingId,
      telcoCharacteristicId,
      telcoCharacteristicValue,
      postalCode = null,
      zone = null,
      zipCode = null,
      dispositivo = null,
      insurance = null,
      mobileRateType = null,
    } = {
      ...getUrlParams({
        groupByObject: false,
        allowedParams: false,
        excludeHash: true,
        currentUrl: window.location.href,
      }),
    };

    if (
      !loaded &&
      mainPostalCode &&
      typeof mainPostalCode === 'string' &&
      mainPostalCode.length === 5
    ) {
      const params = {
        telcoProductOfferingId: productOfferingId,
      };
      if (productOfferingId) {
        const [poId, promotionId] = (productOfferingId || '').split(' ');
        if (promotionId) {
          params.telcoProductOfferingId = poId;
          params.promotionId = promotionId;
        }
      }
      if (dispositivo) {
        params.dispositivo = dispositivo;
      }
      if (insurance) {
        params.insurance = insurance;
      }
      if (telcoCharacteristicId) {
        params.telcoCharacteristicId = telcoCharacteristicId;
      }
      if (telcoCharacteristicValue) {
        params.telcoCharacteristicValue = telcoCharacteristicValue;
      }
      if (postalCode || mainPostalCode) {
        params.postalCode = postalCode || mainPostalCode;
      }
      if (zone) {
        params.zone = zone;
      }
      if (mobileRateType) {
        params.mobileRateType = mobileRateType;
      }
      if (zipCode) {
        if (zipCode === 'libre') {
          params.zone = 'ZL';
        }
        if (zipCode === 'regulada') {
          params.zone = 'ZR';
        }
      }
      if (!params?.zone && mainZone) {
        params.zone = mainZone;
      }
      if (setZone) {
        dispatch(setZone({ zone: params.zone }));
      }
      if (segment) {
        params.segment = segment;
        if (setSegment) {
          dispatch(setSegment({ segment }));
        }
      }
      dispatch(initPurchase(params));
    }
  }, [mainPostalCode]);
}

export default useInitPurchase;
